// prettier-ignore
const unprotectedBaseRoutes = {
  'registration':                           '/rekisteroidy/:token',
  'joinCustomerLogin':                      '/liity/:token',
  'invalidInvitation':                      '/virhe/kutsulinkki',
  'maintenanceBreak':                       '/huoltokatko'
}

// prettier-ignore
const baseRoutes = {
  'root':                                   '/',
  'services':                               '/palvelut',
  'service':                                '/palvelut/:slug',
  'support':                                '/tuki',
  'support.newsletters':                    '/tuki/ajankohtaista',
  'support.newsletter':                     '/tuki/ajankohtaista/:id',
  'support.faq':                            '/tuki/usein-kysytyt-kysymykset',
  'support.contact':                        '/tuki/yhteydenotto',
  'support.contact.closedTickets':          '/tuki/yhteydenotto/suljetut',
  'oma-annos':                              '/oma-annos',
  'oma-annos.orders':                       '/oma-annos/tilaukset',
  'oma-annos.orders.orderChanges':          '/oma-annos/tilaukset/muutokset/:customerId',
  'oma-annos.orders.productShortages':      '/oma-annos/tilaukset/tuotepuutokset',
  'oma-annos.orders.tickets':               '/oma-annos/tilaukset/korjauspyynnot',
  'oma-annos.dispensedProducts':            '/oma-annos/annosjakeluvalikoima',
  'oma-annos.customership':                 '/oma-annos/asiakkuus',
  'oma-annos.customership.reports':         '/oma-annos/asiakkuus/raportit',
  'oma-annos.customership.user':            '/oma-annos/asiakkuus/kayttajat/:id',
  'oma-annos.customership.users':           '/oma-annos/asiakkuus/kayttajat',
  'oma-annos.customership.inviteLinks':     '/oma-annos/asiakkuus/kutsulinkit',
  'oma-annos.customerGroupManagement':      '/oma-annos/asiakkuus/ryhmat',
  'oma-annos.customerGroupManagement.edit': '/oma-annos/asiakkuus/ryhmat/:id',  
  'oma-annos.order-schedules':              '/oma-annos/tilausaikataulut/poikkeukset',
  'user':                                   '/omat-tiedot',
  'user.manage':                            '/omat-tiedot/muokkaa',
  'shop':                                   '/kauppa',
  'shop.own':                               '/kauppa/omat-tuotteet',  
  'shop.orderHistory':                      '/kauppa/tilaus-historia',
  'product':                                '/kauppa/:id',
  'own.product':                            '/kauppa/omat-tuotteet/:id',
  'logout':                                 '/kirjaudu-ulos',
  'notfound':                               '/virhe/404',
  'unauthorized':                           '/virhe/401',
  'wildcard': '*',
  ...unprotectedBaseRoutes
}

export type RouterPaths = typeof baseRoutes & typeof unprotectedBaseRoutes

export type RouteKeys = keyof typeof baseRoutes

export const unprotectedRoutesFi = unprotectedBaseRoutes as typeof unprotectedBaseRoutes

export const routesFi = baseRoutes as RouterPaths

// prettier-ignore
export const unprotectedRoutesEn: typeof unprotectedBaseRoutes = {
  'registration':                           '/registration/:token',
  'joinCustomerLogin':                      '/join/:token',
  'invalidInvitation':                      '/error/invite',
  'maintenanceBreak':                       '/huoltokatko'

}

// prettier-ignore
export const routesEn: RouterPaths = {
  'root':                                   '/',
  'services':                               '/services',
  'service':                                '/services/:slug',
  'support':                                '/support',
  'support.newsletters':                    '/support/news',
  'support.newsletter':                     '/support/news/:id',
  'support.faq':                            '/support/faq',
  'support.contact':                        '/support/contact',
  'support.contact.closedTickets':          '/support/contact/closed',
  'oma-annos':                              '/oma-annos',
  'oma-annos.orders':                       '/oma-annos/orders',
  'oma-annos.orders.orderChanges':          '/oma-annos/orders/changes/:customerId',
  'oma-annos.orders.productShortages':      '/oma-annos/orders/product-shortages',
  'oma-annos.orders.tickets':               '/oma-annos/orders/correction-requests',
  'oma-annos.dispensedProducts':            '/oma-annos/products',
  'oma-annos.customership':                 '/oma-annos/customership',  
  'oma-annos.customership.reports':         '/oma-annos/customership/reports',
  'oma-annos.customership.users':           '/oma-annos/customership/users',
  'oma-annos.customership.user':            '/oma-annos/customership/users/:id',
  'oma-annos.customership.inviteLinks':     '/oma-annos/customership/invite-links',
  'oma-annos.customerGroupManagement':      '/oma-annos/customership/customer-groups',
  'oma-annos.customerGroupManagement.edit': '/oma-annos/customership/customer-groups/:id',
  'oma-annos.order-schedules':              '/oma-annos/order-schedules',
  'user':                                   '/my-info',
  'user.manage':                            '/my-info/manage',
  'shop':                                   '/shop',
  'shop.own':                               '/shop/own-products',
  'shop.orderHistory':                      '/shop/order-history',
  'product':                                '/shop/:id',
  'own.product':                            '/shop/own-products/:id',
  'logout':                                 '/logout',
  'notfound':                               '/error/404',
  'unauthorized':                           '/error/401',
  'wildcard': '*',
  ...unprotectedRoutesEn
}

// prettier-ignore
export const unprotectedRoutesSv: typeof unprotectedBaseRoutes = {
  registration:                             '/registrera/:token',
  joinCustomerLogin:                        '/forena/:token',
  invalidInvitation:                        '/fel/inbjudanlank',
  maintenanceBreak:                         '/huoltokatko'

}

// prettier-ignore
export const routesSv: RouterPaths = {
  'root':                                   '/',
  'services':                               '/tjanster',
  'service':                                '/tjanster/:slug',
  'support':                                '/stod',
  'support.newsletters':                    '/stod/nyheter',
  'support.newsletter':                     '/stod/nyheter/:id',
  'support.faq':                            '/stod/vanliga-fragor',
  'support.contact':                        '/stod/kontakta-oss',
  'support.contact.closedTickets':          '/stod/kontakta-oss/stängda',
  'oma-annos':                              '/oma-annos',
  'oma-annos.orders':                       '/oma-annos/bestallningar',
  'oma-annos.orders.orderChanges':          '/oma-annos/bestallningar/forandringar/:customerId',
  'oma-annos.orders.productShortages':      '/oma-annos/bestallningar/produktbrist',
  'oma-annos.orders.tickets':               '/oma-annos/bestallningar/korrigeringsforfragningar',
  'oma-annos.dispensedProducts':            '/oma-annos/lakemedelsosortimet',
  'oma-annos.customership':                 '/oma-annos/foretagsuppgifter',  
  'oma-annos.customership.reports':         '/oma-annos/foretagsuppgifter/rapporter',
  'oma-annos.customership.user':            '/oma-annos/foretagsuppgifter/anvandare/:id',
  'oma-annos.customership.inviteLinks':     '/oma-annos/foretagsuppgifter/bjud-in-lankar',
  'oma-annos.customership.users':           '/oma-annos/foretagsuppgifter/anvandare',
  'oma-annos.customerGroupManagement':      '/oma-annos/foretagsuppgifter/grupper',
  'oma-annos.customerGroupManagement.edit': '/oma-annos/foretagsuppgifter/grupper/:id',
  'oma-annos.order-schedules':              '/oma-annos/orderscheman',
  'user':                                   '/min-info',
  'user.manage':                            '/min-info/forvalta',
  'shop':                                   '/butik',
  'shop.own':                               '/butik/mina-produkter',  
  'shop.orderHistory':                      '/butik/bestallnings-historik',
  'product':                                '/butik/:id',
  'own.product':                            '/butik/mina-produkter/:id',
  'logout':                                 '/logga-ut',
  'notfound':                               '/fel/404',
  'unauthorized':                           '/fel/401',
  'wildcard': '*',
  ...unprotectedRoutesSv
}
